import { useCallback } from 'react';
import { useNavigate, type To } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@platform/state/hooks';
import { selectCurrentWorkspaceId } from '@platform/state/selectors';
import { workspaceSelected } from '@platform/state/slices/sessionSlice';

/**
 * Відкриття адреси в робочому просторі `ws` (ADR-028: простору немає в адресі): інший простір стає поточним у сесії вкладки разом із
 * переходом — одним синхронним рендером (flushSync), тож поточна сторінка не перечитує свої дані в новому просторі; без простору чи в
 * поточному — лише перехід. Для переходів зі стрічки активності, вхідних, аудиту, перемикача й онбордингу нового простору. Викликати з обробника події.
 */
export function useOpenInWorkspace(): (ws: string | null | undefined, to: To, replace?: boolean) => void {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const current = useAppSelector(selectCurrentWorkspaceId);
  return useCallback((ws: string | null | undefined, to: To, replace?: boolean) => {
    if (ws && ws !== current) dispatch(workspaceSelected(ws));
    navigate(to, { replace, flushSync: true });
  }, [current, dispatch, navigate]);
}
